import React from 'react';
import { Text4 } from '../../../styles';
import moment from 'moment';
import { BATCH_STATUS_TYPES, BATCH_RECORD_STATUS_TYPES, TRANSFER_STATUS_TYPES, VENDOR_INVOICE_STATUS_TYPES } from '../../../constants';
import { Icon, Button, Badge, Menu, Dropdown, Tag } from "antd";


export const renderMenuOverlay = (methods, record) => {
    return (
        <Menu>
            <Menu.Item onClick={() => methods.toggleRecordsDrawer({ ...record })}>Summary</Menu.Item>
            {record.approval ?
                <Menu.Item onClick={() => methods.toggleApprovalsDrawer({ ...record })}>Approvals</Menu.Item>            
            : null}
        </Menu>
    )
}
export const getBulkUploadsTableColumns = (methods) => [
    {
        title: "ID",
        key: "uuid",
        render: (record) => <Text4 className="font-monospace">{record.uuid}</Text4>
    }, {
        title: "Created Date",
        key: "created_at",
        render: (record) => <Text4>{moment(record.created_at).format("lll")}</Text4>
    }, {
        title: "Batch Name",
        key: "name",
        render: (record) => <Text4>{record.name}</Text4>
    }, {
        title: "Batch Status",
        key: "status",
        render: (record) => <Badge color={BATCH_STATUS_TYPES[record.status].color} text={BATCH_STATUS_TYPES[record.status].label} />
    }, {
        title: "Success",
        key: "success",
        render: (record) => <Text4>{record.records_status.find(s => s.status == "completed") && record.records_status.find(s => s.status == "completed").total || 0}/{record.records_count}</Text4>
    }, {
        title: "Actions",
        key: "actions",
        render: (record) =>
                <Dropdown overlay={renderMenuOverlay(methods, record)} >
                    <Button>
                        Actions <Icon type="down" />
                    </Button>
                </Dropdown>
    }
];

export const getRecordsTableColumns = (type, methods) => {
    let columns = [{
        title: "Sr. No.",
        key: "index",
        render: (text, record, index) => <Text4>{index + 1}</Text4>
    }, {
        title: "Created Date",
        key: "created_at",
        render: (record) => <Text4>{moment(record.created_at).format("lll")}</Text4>
    }, {
        title: "Record Status",
        key: "status",
        render: (record) => <Badge color={BATCH_RECORD_STATUS_TYPES[record.status].color} text={BATCH_RECORD_STATUS_TYPES[record.status].label} />
    }];
    if (type == "transfer") {
        columns.push({
            title: "Transfer URN",
            key: "transfer_urn",
            width: "25%",
            render: (record) => <Text4>{record.record_params.unique_request_number || "---"}</Text4>
        });
        columns.push({
            title: "Transfer Status",
            key: "transfer_status",
            render: (record) => <Text4>{record.record.status ? TRANSFER_STATUS_TYPES[record.record.status].label : "---"}</Text4>
        });
    }
    else if (type == "beneficiary") {
        columns.push({
            title: "Beneficiary Name",
            key: "beneficiary_name",
            render: (record) => <Text4>{record.record_params.beneficiary_name || "---"}</Text4>
        })
        columns.push({
            title: "Beneficiary Status",
            key: "beneficiary_status",
            render: (record) => <Text4>{record.record_uuid ? "Created" : "---"}</Text4>
        });
    }
    else if(type == "instacollect_order"){
        columns.push({
            title: "Merchant Request Number",
            key: "unique_request_number",
            render: (record) => <Text4>{record.record_params.unique_request_number || "---"}</Text4>
        })
        columns.push({
            title: "Amount",
            key: "amount",
            render: (record) => <Text4>{record.record_params.amount || "---"}</Text4>
        })
        columns.push({
            title: "Per Transaction Amount",
            key: "per_transaction_amount",
            render: (record) => <Text4>{record.record_params.per_transaction_amount || "---"}</Text4>
        })
    }
    else if(type== 'vendor'){
        columns.push({
            title: "Vendor Name",
            key: "name",
            render: (record) => <Text4>{record.record_params.name || "---"}</Text4>
        })
        columns.push({
            title: "Vendor Email",
            key: "email",
            render: (record) => <Text4>{record.record_params.email}</Text4>
        });
    }
    else if(type== 'vendor_invoice'){
        columns.push({
            title: "Invoice Number",
            key: "invoice_number",
            render: (record) => <Text4>{record.record_params.invoice_number || "---"}</Text4>
        })
        columns.push({
            title: "Invoice Status",
            key: "invoice_status",
            render: (record) => <>{record.record_params.invoice_status ? 
                <Badge color={VENDOR_INVOICE_STATUS_TYPES[record.record_params.invoice_status].color} text={VENDOR_INVOICE_STATUS_TYPES[record.record_params.invoice_status].label} />
                :'---'}</>
        });
    }
    else if(type== 'penny_drop'){
        columns.push({
            title: "Account Number",
            key: "account_no",
            render: (record) => <Text4>{record.record_params.account_no}</Text4>
        })
        columns.push({
            title: "IFSC Code",
            key: "ifsc",
            render: (record) => <Text4>{record.record_params.ifsc}</Text4>
        })
    }
    else if(type== 'payout_link'){
        columns.push({
            title: "Unique Code",
            key: "account_no",
            render: (record) => <Text4>{record.record_params.unique_code}</Text4>
        })
    }
    columns.push({
        title: "Actions",
        key: "actions",
        render: (record) => <Button size="small" onClick={() => methods.toggleRecordDetailsDrawer({ ...record })}>Details</Button>
    });
    return columns;
};

// export const bulkUploadsTableFilterNodes = (defaultFilters, current_user) => {
export const bulkUploadsTableFilterNodes = (defaultFilters) => {

    // let nodes = [{
        return [{
        label: "Created Date",
        field: "created_at",
        placeholder: "Enter Created Date",
        inputType: "date_range",
        defaultValue: [moment().subtract(3, 'days'), moment()],
        preventClear:true,
    }, {
        label: "Batch Name",
        field: "name",
        placeholder: "Enter Batch Name",
        inputType: "text",
        defaultValue: ""
    }, {
        label: "Type",
        field: "batch_type",
        placeholder: "Select Operation Type",
        inputType: "select",
        preventClear: true,
        defaultValue: defaultFilters.batch_type,

        options: [{
            key: "1",
            value: "transfer",
            label: "Transfer"
        }, {
            key: "2",
            value: "beneficiary",
            label: "Beneficiary"
        }, {
            key: "3",
            value: "instacollect_order",
            label: "InstaCollect Order"
        },
        , {
            key: "4",
            value: "vendor",
            label: "Vendor"
        }, {
            key: "5",
            value: "vendor_invoice",
            label: "Vendor Invoice"
        }, {
            key: "6",
            value: "penny_drop",
            label: "Penny Drop"
        }, {
            key: "7",
            value: "advanced_penny_drop",
            label: "Advanced Penny Drop"
        },
        {
            key: "8",
            value: "payout_link",
            label: "Bulk Payout Links"
        }
    
    ]
    }, {
        label: "Status",
        field: "status",
        placeholder: "Select Status",
        inputType: "select",
        defaultValue: undefined,
        options: Object.keys(BATCH_STATUS_TYPES).map((type, index) => {
            let object = {};
            object.key = index;
            object.value = type;
            object.label = BATCH_STATUS_TYPES[type].label;
            return object;
        })
    }];
    // if (current_user.is_reseller && current_user.esda){
    //     nodes.unshift({
    //         label: "Merchant",
    //         field: "submerchant_id",
    //         placeholder: "Merchant ID",
    //         width: 250,
    //         inputType: "select",
    //         showSearch: true,
    //         defaultValue: undefined,
    //         options: current_user.submerchants ? current_user.submerchants.map((sub_merchant, index) => {
    //             let object = {};
    //             object.key = index;
    //             object.value = sub_merchant.id;
    //             object.label = sub_merchant.name+" ("+sub_merchant.email+")"
    //             return object;
    //         }): []

    //     })
    // }
    // return nodes

}

export const bulkErrorColumns = [{
    title: "Field",
    key: "field",
    render: (record) => <Text4>{record.field}</Text4>
}, {
    title: "Error Category",
    key: "category",
    render: (record) => <Text4>{record.category}</Text4>
}, {
    title: "Row Numbers",
    key: "row_numbers",
    render: (record) => <Text4>{record.row_numbers}</Text4>
}, {
    title: "Error Message",
    key: "message",
    render: (record) => <Text4>{record.message}</Text4>
}];